import React from 'react';
import styled from 'styled-components';
import { isArray, startsWith } from 'lodash';
import { withRouter, NavLink } from 'react-router-dom';

import { colors } from '../variables';

const linkInactiveColor = '#777676';

const ItemContainer = styled.li`
	display: block;
	margin: 0;
	padding: 0;
`;

const Item = styled.div`
	padding: 16px 16px 16px 42px;
	display: block;
	text-decoration: none;
	cursor: pointer;
	background: transparent;

	&:after {
		content: '';
		display: block;
		clear: both;
	}

	&:hover,
	&:focus {
		background: ${colors.yellow.bromma};
	}
`;

// Icons removed in redesign

const Name = styled.h3`
	text-transform: uppercase;
	color: #000;
	font-weight: 400;
	font-size: 12px;
	margin: 0;
	letter-spacing: 0px;
`;

const SubMenu = styled.ul`
	margin: 0;
	padding: 0 0 0 0;
	background: transparent;

	a {
		display: block;
		padding: 12px 20px 12px 56px;
		color: #000;
		text-decoration: none;
		font-weight: 400;
		font-size: 12px;

		&:hover,
		&:focus:not([target='_blank']),
		&.active {
			background: ${colors.yellow.bromma};
			color: #000;
		}
	}
`;

// Check if an item is active
const itemIsActive = (to, pathname) => {
	// Check if any of the to values (array given) starts with the path
	if (isArray(to)) {
		return to.filter(rule => startsWith(pathname, rule)).length > 0;
	}

	// Check if the to string starts with the pathname
	return startsWith(pathname, to);
};

class SubMenuContaienr extends React.Component {
	render() {
		const { name, items } = this.props;

		const isActive = itemIsActive(this.props.to, this.props.location.pathname);
		const isExpanded = this.props.expanded === name;
		const className = isActive ? 'active' : '';

		const authorizedItems = items.filter(item => item.canAccess);

		return (
			<ItemContainer>
				<Item onClick={() => this.props.toggle(name)} className={className}>
					<Name>{name}</Name>
				</Item>

				{(isExpanded || isActive) && (
					<SubMenu>
						{authorizedItems.map(item => (
							<li key={item.to}>
								{item.external ? (
									<a href={item.to} target="_blank" rel="noopener noreferrer">
										{item.name}
									</a>
								) : (
									<NavLink
										to={item.to}
										exact={item.exact}
										onClick={this.props.onClick}
									>
										{item.name}
									</NavLink>
								)}
							</li>
						))}
					</SubMenu>
				)}
			</ItemContainer>
		);
	}
}

export default withRouter(SubMenuContaienr);



// WEBPACK FOOTER //
// ./src/components/Sidebar/SubMenuContainer.js